import { DialogTitle } from '@headlessui/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { usePartnerContext, useUserContext } from '../context'
import {
  clearAutoSwitchNotice,
  readAutoSwitchNotice
} from '../helpers/space-auto-switch'
import Button from './tailwind/Button'
import Modal from './tailwind/Modal'

// Hinweis nach einem automatischen Standortwechsel (hooks/use-space-fallback.js).
// Er erscheint im Zielstandort, erklärt den Grund und den Rückweg und wird nur
// einmal gelesen, beim Mount. Schließen löscht ihn, ein Reload zeigt ihn also
// nicht noch einmal. Er passt nur zum Zielstandort und verfällt nach zehn
// Minuten, siehe helpers/space-auto-switch.js.
const SpaceAutoSwitchNotice = () => {
  const { t } = useTranslation()
  const { user, activeSpace } = useUserContext()
  const { partner } = usePartnerContext()

  const [notice] = useState(() =>
    readAutoSwitchNotice({ user: user.id, activeSpaceId: activeSpace.id })
  )
  const [isOpen, setIsOpen] = useState(!!notice)

  if (!notice) return null

  const handleClose = () => {
    setIsOpen(false)
    clearAutoSwitchNotice({ user: user.id })
  }

  return (
    <Modal
      open={isOpen}
      setOpen={(open) => {
        if (!open) handleClose()
      }}
    >
      <DialogTitle
        as='h2'
        className='pr-10 text-xl font-bold tracking-tight text-gray-900'
      >
        {t('components.space_auto_switch.title')}
      </DialogTitle>
      <p className='mt-2 text-sm text-gray-500'>
        {t('components.space_auto_switch.description', {
          from:
            notice.fromName ||
            t('components.space_auto_switch.previous_location'),
          to: partner.name
        })}
      </p>
      <div className='mt-6 flex justify-end'>
        <Button.PrimaryLG
          text={t('components.space_auto_switch.action')}
          onClick={handleClose}
        />
      </div>
    </Modal>
  )
}

export default SpaceAutoSwitchNotice
